import React from 'react';
import { ComponentType, LectureComponent } from 'redux/schemas/models/lecture-component';
import { AiSuggestedComponentProps } from 'redux/schemas/models/ai-course-creation';
import { Exercise } from 'redux/schemas/models/exercise';
import QuizQuestions from './quiz-questions';
import PollQuestion from './poll-question';
import SurveyQuestion from './survey-question';
import ActivityDescription from '../activity-description';

const ActivityInfo = ({ componentSet }: AiSuggestedComponentProps) => {
  switch (componentSet.activity.type) {
    case ComponentType.PROFILE_COMPLETION:
      return (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: componentSet.activity.content }}
        />
      );
    case ComponentType.TOPIC:
      return (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: (componentSet.activity as LectureComponent<ComponentType.TOPIC>).topic.body }}
        />
      );
    case ComponentType.EXERCISE:
      return (
        <div
          // here the type is TimelineExercise, We are not normalizing the components
          // for suggest activities. so Cast the exercise to the correct type
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: (componentSet.activity.exercise as unknown as Exercise).description }}
        />
      );
    case ComponentType.PUBLIC_PEER_EVALUATION:
      return <ActivityDescription description={componentSet.activity.peerEvaluation.description} />;
    case ComponentType.QUIZ:
      return <QuizQuestions componentSet={componentSet} />;
    case ComponentType.POLL:
      return <PollQuestion componentSet={componentSet} />;
    case ComponentType.SURVEY:
      return <SurveyQuestion componentSet={componentSet} />;
    default:
      return null;
  }
};

export default ActivityInfo;
